export default __webpack_public_path__ + "static/media/joyful_jump_l.5442b092.gif";